<main>
  <loading-overlay [isLoading]="isLoading"></loading-overlay>
  <p-toast></p-toast>

  <header>
    <div class="headline">
      <h1>
        {{ shipment?.shipmentNumber }}
      </h1>
      <csl-dropdown [enumObject]="shipmentStatusEnumObject" [enumValueOptions]="shipmentStatusOptions" [formControl]="shipmentStatus" enumName="ShipmentStatus" />
    </div>
    <div class="buttons">
      <p-button
        *ngIf="shipment?.id && shipmentStatus.value === 6"
        label="{{ 'Transfer_Units_Details_Download_Report' | translateWF: 'Download Report' }}"
        icon="pi pi-download"
        size="small"
        [outlined]="true"
        (click)="downloadShipmentReport()"
      >
      </p-button>
    </div>
  </header>

  <div class="content">
    <p-panel [header]="'Warehouse_Imports_Details_Details' | translateWF: 'Details'">
      <div class="col-sm">
        <p-card>
          <div class="grid-auto-4">
            <div class="form-box">
              <label>{{ 'Warehouse_Imports_Details_Tracking' | translateWF: 'Tracking' }}</label>
              <input type="text" pInputText class="w-full" [value]="shipment?.trackingNumber ?? ''" [disabled]="true" />
            </div>

            <div class="form-box">
              <label>{{ 'Warehouse_Imports_Details_Created_Date' | translateWF: 'Created Date' }}</label>
              <input type="date" pInputText class="w-full" [value]="shipment?.createdDate | date: 'yyyy-MM-dd'" [disabled]="true" />
            </div>

            <div class="form-box">
              <label>{{ 'Warehouse_Imports_Details_Shipment_Date' | translateWF: 'Shipment Date' }}</label>
              <input type="date" pInputText class="w-full" [value]="shipment?.actualArrivalDate | date: 'yyyy-MM-dd'" [disabled]="true" />
            </div>
          </div>
        </p-card>

        @if (isConsignment) {
          <p-panel data-tone="surface" [header]="'Warehouse_Imports_Details_Delivery_Notes' | translateWF: 'Delivery Notes'">
            <p-card data-variant="flat">
              <ul class="invoice-list-selection">
                <li *ngFor="let deliveryNote of deliveryNotes; let i = index">
                  <div class="text row-sm-start-center">
                    <span>#{{ i + 1 }}</span>
                    <p class="cursor-pointer">{{ deliveryNote.number }}</p>
                    <i class="pi pi-eye text-primary cursor-pointer ml-auto" (click)="redirectToDeliveryNoteDetails(deliveryNote.id!)" title="View Delivery Note"></i>
                  </div>
                </li>
              </ul>
            </p-card>
          </p-panel>
        } @else {
          <p-panel data-tone="surface" [header]="'Warehouse_Imports_Details_Invoices' | translateWF: 'Invoices'">
            <p-card data-variant="flat">
              <ul class="invoice-list-selection">
                <li *ngFor="let invoice of invoices; let i = index">
                  <div class="text row-sm-start-center">
                    <span>#{{ i + 1 }}</span>
                    <p class="cursor-pointer">{{ invoice.invoiceNumber }}</p>
                    <i class="pi pi-eye text-primary cursor-pointer ml-auto" (click)="redirectToInvoiceDetails(invoice.id)" title="View Invoice"></i>
                  </div>
                </li>
              </ul>
            </p-card>
          </p-panel>
        }
      </div>
    </p-panel>

    <p *ngIf="!isShipmentReadyToUnload && !isShipmentCompleted">
      {{ 'Warehouse_Imports_Details_Unloading_Message' | translateWF: 'Unloading Message' }}
    </p>

    <p-panel [header]="'Warehouse_Imports_Details_Inventory_Transactions' | translateWF: 'Inventory Transactions'">
      <ng-template pTemplate="icons">
        <!-- QR Scanner Modal -->
        <app-qr-scanner-modal *ngIf="canEdit()" (isScannedCode)="onQrCodeScanned($event)" />
      </ng-template>
      @for (inventoryTransaction of inventoryTransactions; track $index) {
        <app-inventory-transaction
          [inventoryTransaction]="inventoryTransaction"
          [isShipmentReadyToUnload]="isShipmentReadyToUnload"
          [shipmentStatus]="shipmentStatus.value"
          [dischargingLotItems]="true"
          [isConsignment]="isConsignment"
          [lotItems]="getAllLotItems()"
          type="warehouse-import"
        ></app-inventory-transaction>
      }
      @for (item of uniqueScanned; track $index) {
        <p-tag>{{ item }}</p-tag>
      }
    </p-panel>
  </div>
</main>
